import { useGetQaIntegrationDetailQuery, useGetQaIntegrationListQuery } from 'services';
import { QaDetail, QaIntegrationRequestDto } from 'types';

export function useGetQaIntegrationList(qaIntegrationReqDto: QaIntegrationRequestDto) {
  const {
    data: dataResponse,
    isLoading,
    isFetching,
    refetch
  } = useGetQaIntegrationListQuery({
    ...qaIntegrationReqDto
  });

  return {
    data: dataResponse?.data || [],
    refetch: refetch ?? (() => {}),
    isFetching,
    isLoading
  };
}

export function useGetQaIntegrationDetail(qaIntegrationReqDto: number) {
  const { data: dataResponse, isLoading, isFetching } = useGetQaIntegrationDetailQuery(qaIntegrationReqDto);

  return {
    data: dataResponse?.data || Default_QaIntegrationDetail,
    isFetching,
    isLoading
  };
}

const Default_QaIntegrationDetail: QaDetail = {
  id: 0,
  evaluator: '',
  evaluationDate: '',
  evaluationStatus: 0,
  recordingLink: '',
  videoLink: '',
  evaluationStatusDescription: '',
  completionDate: '',
  evaluationContent: '',
  feedbackContent: '',
  totalScore: 0,
  criteriaVersion: 0,
  totalDeductedScore: 0,
  criteriaData: [],
  detailedEvaluationInfo: {}
};
